export default __webpack_public_path__ + "static/ERS-24b2b8bbbe59550c88bc972cf576418c.jpg";